//components
import { BasicButton, SimpleTable} from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import SimpleBar from 'simplebar-react';

//hooks and helpers
import UseLegacyAppUsers from './LegacyAppUsers.hooks';
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';

//styling
import "../../../../css/orgSettings/passkeys/legacy-app-users-modal.scss"



const LegacyAppUsersModal = ({orgId, legacyAppUserCount, totalUserCount, showModal, hideModal} : {orgId: string, legacyAppUserCount:number, totalUserCount:number, showModal: boolean, hideModal: () => void}) => {
    const {tableContent, simpleBarRef, autoScrollHandler,  getMoreUsers, tableHeight} = UseLegacyAppUsers(orgId, showModal);

    return (
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="legacy-app-users-modal" 
            isFullPage
        >
                <div className="legacy-app-users-content">
                    <h1 className='header-text'>{`Users on older app versions (${legacyAppUserCount}/${totalUserCount})`}</h1> 
                
                    <SimpleBar 
                        className='legacy-app-simple-bar' 
                        style={{ height: tableHeight }} 
                        scrollableNodeProps={{  
                            ref: simpleBarRef, 
                            onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, autoScrollHandler, getMoreUsers) 
                        }}
                        >
                        <SimpleTable 
                            {...tableContent}
                        />
                    </SimpleBar>  
                                     
                    <div className='modal-button-panel'>
                        <BasicButton 
                            content={"Close"}  
                            className={"close-button"}  
                            ariaLabel={'Close Modal'} 
                            onButtonClick={hideModal}
                        />
                    </div>
                </div>
        </ModalWrapper> 
    );  
}

export default LegacyAppUsersModal;
